// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  skillId: __t.u64().primaryKey().name("skill_id"),
  versonaId: __t.u64().name("versona_id"),
  recipeKey: __t.string().name("recipe_key"),
  level: __t.f32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
